<template>
  <div class="card_wrap">
    <!-- 企业对公账户 -->
    <el-card class="box-card">
      <div style="font-size: 20px; font-weight: bold">企业对公账户</div>
      <div class="account_info_row" style="margin-top: 15px">
        <span class="account_info_label">企业名称:</span>
        <span class="account_info_value">{{
          currentCompany.branchName || "--"
        }}</span>
      </div>
      <!-- 账户余额 -->
      <div class="account_info_row" style="margin-top: 15px">
        <span class="account_info_label">账户余额(元):</span>
        <b class="highlight">{{
          showAmount
            ? accountAmount
            : "*".repeat(accountAmount ? accountAmount.toString().length : 6)
        }}</b>
        <img
          class="psw_icon"
          @click="showAmount = !showAmount"
          v-if="!showAmount"
          src="@/assets/icon/pswhidden.png"
          alt=""
        />
        <img
          class="psw_icon"
          @click="showAmount = !showAmount"
          v-else
          src="@/assets/icon/pswshow.png"
          alt=""
        />
        <div @click="refreshBalance">
          <span class="refresh_btn_text" @click="branchGetSelfBlance('refresh')"
            >刷新</span
          >
          <!-- <i class="el-icon-refresh refresh_icon" @click="refreshCompany"></i> -->
        </div>
        <!-- <img class="payed_text" src="@/assets/icon/tixian.png" alt="" /> -->
        <span class="refresh_btn_text" @click="withdrawal(2, accountAmount)"
          >提现</span
        >
      </div>
      <!-- 待支付金额 -->
      <div class="account_info_row m_b_0" style="margin-top: 15px">
        <span class="account_info_label">利息收入(元):</span>
        <b class="highlight">{{
          showPending
            ? accountTax
            : "*".repeat(accountTax ? accountTax.toString().length : 6)
        }}</b>
        <img
          class="psw_icon"
          @click="showPending = !showPending"
          v-if="!showPending"
          src="@/assets/icon/pswhidden.png"
          alt=""
        />
        <img
          class="psw_icon"
          @click="showPending = !showPending"
          v-else
          src="@/assets/icon/pswshow.png"
          alt=""
        />
        <div @click="refreshBalance">
          <!-- todo: -->
          <span
            class="refresh_btn_text"
            @click="branchGetSelfBlance2('refresh')"
            >刷新</span
          >
          <!-- <i class="el-icon-refresh refresh_icon" @click="refreshNoPay"></i> -->
        </div>
        <!-- <img class="payed_text" src="@/assets/icon/tixian.png" alt="" /> -->
        <span class="refresh_btn_text" @click="withdrawal(1, accountTax)"
          >提现</span
        >
      </div>
    </el-card>
    <!-- 平台收款账户 -->
    <el-card class="box-card" style="margin-top:15px;margin-bottom:15px;">
      <div
        style="font-size: 20px; font-weight: bold;display:flex;align-items: center;"
      >
        <div>平台收款账户</div>
      </div>
      <div class="account_info_row" style="margin-top: 15px">
        <span class="account_info_label">账户名称:</span>
        <span class="account_info_value">{{
          currentCompany.branchName || "--"
        }}</span>
        <span class="copy_text" @click="copyText(currentCompany.branchName)"
          >复制</span
        >
        <!-- <img
          @click="copyText(currentCompany.branchName)"
          style="width:25px;height:25px;"
          src="@/assets/icon/copy.png"
          alt=""
        /> -->
      </div>
      <div class="account_info_row">
        <span class="account_info_label">开户银行:</span>
        <span class="account_info_value">{{
          currentCompany.openingBank || "--"
        }}</span>
        <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.openingBank)"
                >复制</span
              > -->
        <!-- <img
          class="copy_text"
          @click="copyText(currentCompany.openingBank)"
          style="width:25px;height:25px;"
          src="@/assets/icon/copy.png"
          alt=""
        /> -->
        <span class="copy_text" @click="copyText(currentCompany.openingBank)"
          >复制</span
        >
      </div>
      <div class="account_info_row">
        <span class="account_info_label">银行账号:</span>
        <span class="account_info_value">{{
          currentCompany.bankAccount || "--"
        }}</span>
        <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.bankAccount)"
                >复制</span
              > -->
        <!-- <img
          class="copy_text"
          @click="copyText(currentCompany.bankAccount)"
          style="width:25px;height:25px;"
          src="@/assets/icon/copy.png"
          alt=""
        /> -->
        <span class="copy_text" @click="copyText(currentCompany.bankAccount)"
          >复制</span
        >
      </div>
      <!-- TODO: -->
      <div class="account_info_row">
        <span class="account_info_label">开户支行:</span>
        <span class="account_info_value">{{
          currentCompany.openingBranch || "--"
        }}</span>
        <span class="copy_text" @click="copyText(currentCompany.openingBranch)"
          >复制</span
        >
        <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.branchName)"
                >复制</span
              > -->
        <!-- <img
                class="copy_text"
                @click="copyText(currentCompany.branchName)"
                style="width:25px;height:25px;"
                src="@/assets/icon/copy.png"
                alt=""
              /> -->
      </div>
      <div class="account_info_row">
        <span class="account_info_label">银联号:</span>
        <span class="account_info_value">{{
          currentCompany.subBankAccount || "--"
        }}</span>
        <span class="copy_text" @click="copyText(currentCompany.subBankAccount)"
          >复制</span
        >
        <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.subBankAccount)"
                >复制</span
              > -->
        <!-- <img
                class="copy_text"
                @click="copyText(currentCompany.subBankAccount)"
                style="width:25px;height:25px;"
                src="@/assets/icon/copy.png"
                alt=""
              /> -->
      </div>
      <el-button type="primary" class="all_copy" @click="copyAll"
        >一键复制</el-button
      >
    </el-card>
    <el-dialog
      title="提现"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="withdrawal_type">
        提现金额
      </div>
      <div class="withdrawal_input">
        <div class="withdrawal_input_money">￥</div>
        <el-input v-model="accountNum" placeholder="请输入提现金额" />
      </div>
      <div class="withdrawal_balance">
        <span class="withdrawal_balance_money">当前余额{{ allAmount }}元,</span>
        <span class="withdrawal_balance_all" @click="changeAllAmount"
          >全部提现</span
        >
      </div>
      <div class="withdrawal_footer">
        <!-- <div class="withdrawal_footer_cancel">取消</div>
        <div class="withdrawal_footer_confirm">确认提现</div> -->
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          :loading="loadingRevenu"
          type="primary"
          @click="revenueWithdrawApi"
          >确认提现</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { revenueWithdraw } from "@/api/shipment";
export default {
  name: "CardInfo",
  props: {
    currentCompany: {
      type: Object,
      default: {}
    },
    accountAmount: {
      type: String,
      default: 0
    },
    accountTax: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      showAmount: false,
      showPending: false,
      dialogVisible: false,
      accountNum: null,
      allAmount: 0,
      revenuType: null,
      loadingRevenu: false
    };
  },

  mounted() {},

  methods: {
    revenueWithdrawApi() {
      if (+this.accountNum === 0) {
        this.$message({
          message: "暂无可提取的金额",
          type: "warning",
          duration: 1500
        });
        return;
      }
      this.loadingRevenu = true;
      revenueWithdraw({
        branchCode: this.currentCompany.branchCode,
        outAmount: this.accountNum,
        flag: this.revenuType //flag   1:利息  2:余额
      })
        .then(res => {
          this.loadingRevenu = false;
          this.dialogVisible = false;
          this.$message({
            message: "提现成功",
            type: "success",
            duration: 1500
          });
          this.$emit("refreshCompany");
        })
        .finally(() => {
          this.loadingRevenu = false;
        });
    },
    changeAllAmount() {
      this.accountNum = this.allAmount;
    },
    withdrawal(type, amount) {
      if (+amount === 0) {
        this.$message({
          message: "暂无可提取的金额",
          type: "warning",
          duration: 1500
        });
        return;
      }
      this.revenuType = type;

      this.dialogVisible = true;
      this.allAmount = amount;
    },
    branchGetSelfBlance(data) {
      this.$emit("branchGetSelfBlance", data);
    },
    branchGetSelfBlance2(data) {
      this.$emit("branchGetSelfBlance2", data);
    },
    refreshCompany() {
      this.$emit("refreshCompany");
    },
    refreshNoPay() {
      this.$emit("refreshNoPay");
    },
    refreshBalance() {},
    copyAll() {
      let str = `
        账户名称:${this.currentCompany.branchName}
        开户银行:${this.currentCompany.openingBank}
        银行账户:${this.currentCompany.bankAccount}
        开户支行:${this.currentCompany.openingBranch}
        银联号:${this.currentCompany.subBankAccount}
      `;
      this.copyText(str);
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    }
  }
};
</script>
<style lang="scss">
.card_wrap {
  .el-dialog__body {
    padding: 5px 20px 26px !important;
  }
}
</style>
<style scoped lang="scss">
.withdrawal_footer {
  display: flex;
  margin-top: 24px;
  justify-content: flex-end;
  .withdrawal_footer_cancel {
  }
  .withdrawal_footer_confirm {
  }
}
.withdrawal_balance {
  margin-top: 8px;
  .withdrawal_balance_money {
    font-weight: 400;
    font-size: 14px;
    color: #777777;
  }
  .withdrawal_balance_all {
    font-weight: 400;
    font-size: 14px;
    color: #4186ef;
    cursor: pointer;
  }
}
.withdrawal_input {
  display: flex;
  align-items: center;
  .withdrawal_input_money {
    font-weight: bold;
    font-size: 28px;
    color: #333333;
  }
}
.withdrawal_type {
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  line-height: 24px;
  text-align: left;
  margin-bottom: 24px;
}
.tips_box {
  font-size: 13px;
  background: #f3f3f3;
  border-radius: 10px;
  padding: 10px;
  .m_r_20 {
    margin-left: 20px;
  }
}
.item_height {
  height: 720px;
}
.account_info_title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 5px;
  flex-wrap: wrap;

  .title_h2 {
    font-size: 20px;
    font-weight: bold;
    margin-right: 20px;
  }
}
.title_top_box {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  // border:1px solid;
}
.back-button {
  width: 79px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #409eff;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
  margin-left: -20px;
  margin-top: -3px;
  &:hover {
    background-color: #ecf5ff;
  }

  i {
    margin-right: 5px;
    font-size: 14px;
  }
}
.account_info_tips {
  color: #a3a3a3;
  flex: 1;
  display: flex;
  align-items: center;
}

.account_info_row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  // border-bottom: 1px dashed #ebeef5;
}

.m_b_0 {
  margin-bottom: 0px !important;
}

.account_info_label {
  width: 130px;
  color: #606266;
  font-weight: 600;
  margin-right: 15px;
  text-align: right;
  font-size: 15px;
}

.account_info_value {
  color: #303133;
  font-size: 15px;
  min-width: 200px;
}

.container_account_box {
  padding: 30px;
}
.container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 15px;
}

.account-card,
.record-card {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.company-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #2a6efd;
}

.balance-row {
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.balance-row > span {
  margin-right: 10px;
}

.highlight {
  font-size: 18px;
  color: #f56c6c;
  margin-right: 8px;
}

.bank-account {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.bank-account i {
  margin-left: 8px;
  color: #2a6efd;
}

.refresh_btn_box {
  display: flex;
  align-items: center;
}

.refresh_btn_text {
  margin-right: 15px;
  color: #409eff;
  cursor: pointer;
  &:hover {
    cursor: pointer;
  }
}
.payed_text {
  width: 30px;
  height: 20px;
  color: #2a6efd;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}
.refresh_icon {
  color: #2a6efd;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}

.help-tips {
  margin-top: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}

.help-tips p {
  margin: 5px 0;
}

/* 轮播相关样式 */
.record-carousel-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 180px;
}

.record-type-buttons {
  padding: 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  // justify-content: center;
}

.el-carousel {
  height: 720px;
  // border: 2px solid red;
}

.el-carousel__item {
  padding: 20px;
  // overflow-y: auto;
}

/* 确保轮播项内容不会溢出 */
.el-carousel__container {
  height: 100%;
}
.no_company_box {
  margin-top: 30px;
  margin-bottom: 190px;
}
.psw_icon {
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.copy_text {
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
  &:hover {
    opacity: 0.6;
  }
}
.all_copy {
  margin-left: 138px;
  margin-bottom: 15px;
}
</style>
